import { useCallback, useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router';

import { type Mode, isConnectionMode } from '.';

export const useConnectionMode = ({
  mustAcceptTCU,
}: {
  mustAcceptTCU: boolean;
}): [Mode | null, (newMode: Mode | null) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionParam = searchParams.get('action');
  const connectionMode = isConnectionMode(actionParam) ? actionParam : null;
  const { state: locationState } = useLocation();

  const setConnectionMode = useCallback(
    (newMode: Mode | null) => {
      setSearchParams(
        prev => {
          if (newMode) {
            prev.set('action', newMode);
          } else {
            prev.delete('action');
          }
          return prev;
        },
        {
          state: locationState,
          preventScrollReset: true,
        }
      );
    },
    [setSearchParams, locationState]
  );

  const shouldRedirectToTerms =
    connectionMode === 'showTerms' && !mustAcceptTCU;

  /** Reset mode once the navigation to the terms page removed the action */
  useEffect(() => {
    if (shouldRedirectToTerms) {
      setConnectionMode(null);
    }
  }, [shouldRedirectToTerms, setConnectionMode]);

  return [connectionMode, setConnectionMode];
};
